import { getProjectSiteAri } from '@atlassian/projects-goals-common/get-app-site-ari';
import type { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { RouteResource } from '@townsquare/router/resources/types';
import type { ResourceContext } from '@townsquare/router/types';

import { type AggProjectTabName, DEFAULT_TAB, isAggProjectTab } from '../agg-project-tabs';
import ProjectTabContentAggQuery, {
	type ProjectTabContentAggQuery as ProjectTabContentAggQueryType,
} from '../components/__generated__/ProjectTabContentAggQuery.graphql';

const getTabBooleans = (tabName: AggProjectTabName) => ({
	isUpdatesTab: tabName === 'updates',
	isLearningsTab: tabName === 'learnings',
	isRisksTab: tabName === 'risks',
	isDecisionsTab: tabName === 'decisions',
});

export const aggProjectViewTabResource: RouteResource<
	PreloadedQuery<ProjectTabContentAggQueryType, Record<string, unknown>>
> = createRelayResource<ProjectTabContentAggQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;

		const rawCloudId = context.workspace?.cloudId;

		if (!rawCloudId) throw new Error('No cloudId available');

		const containerId = getProjectSiteAri(rawCloudId);

		const tabParam = routerContext.match.params.tabName;
		const currentTab: AggProjectTabName =
			tabParam && isAggProjectTab(tabParam) ? tabParam : DEFAULT_TAB;

		return {
			query: ProjectTabContentAggQuery,
			environment: getAggRelayEnvironment(),
			variables: {
				projectKey: routerContext.match.params.id ?? '',
				containerId,
				...getTabBooleans(currentTab),
			},
		};
	},
});
